import { ReactNode } from 'react';
import { TableHeader } from './components/TableHeader';

interface TableProps {
  header: string[];
  tableRow?: ReactNode;
  headerClassName?: string;
}

export const Table = ({ header, tableRow, headerClassName }: TableProps) => {
  return (
    <table className="w-full">
      <thead className="rounded-md">
        <tr>
          <TableHeader header={header} headerClassName={headerClassName} />
        </tr>
      </thead>
      <tbody>{tableRow}</tbody>
    </table>
  );
};
